module.exports = __webpack_public_path__ + "images/interview-KPMG-2.svg";